import '../scss/main.scss';
import './core/mixins/mixins';
import WebFont from 'webfontloader';
import { app } from './core/App';
import { scenes } from './app-routing';

WebFont.load({
  classes: false,
  custom: {
    families: ['FREDFREDBURGER-REGULAR', 'FREDFREDBURGER-BOLD', 'FREDFREDBURGERHEADLINE-BLACK']
  },
  active: () => {
    app.AssetManager.fontsReady();
    console.log('All fonts loaded');
  }
});

window.addEventListener('load', function () {
  const game = new Phaser.Game({
    ...app.GameConfig,
    // width: 800,
    // height: 600,
    // backgroundColor: '#2f2f2f',
    // scale: {a
    //   mode: Phaser.Scale.ScaleModes.FIT,
    //   autoCenter: Phaser.Scale.Center.CENTER_BOTH
    // },
    physics: {
      default: 'matter',
      matter: {
        debug: !__IS_PRODUCTION__,
        enabled: false,
        gravity: false
      },
    },
    fps: {
      target: 30
    },
    scene: scenes
  });

  app.afterGame(game, () => {
    game.scene.start(app.Config.bootScene);
  });
});
